import React, { useState } from 'react';
import {
    Container, Typography, Button, List, ListItem, ListItemText,
    IconButton, TextField, RadioGroup, FormControlLabel, Radio,
    Menu, MenuItem, Select, Box,
    Paper,
    FormControl,
    InputLabel
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddIcon from '@mui/icons-material/Add';
import MyLocationOutlinedIcon from '@mui/icons-material/MyLocationOutlined';

function ManageAddress() {
    const [showForm, setShowForm] = useState(false);
    const [addresses, setAddresses] = useState([]);
    const [address, setAddress] = useState({
        name: '',
        mobile: '',
        pincode: '',
        locality: '',
        address: '',
        city: '',
        state: '',
        landmark: '',
        alternatePhone: '',
        addressType: 'home'
    });

    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedAddressIndex, setSelectedAddressIndex] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setAddress({ ...address, [name]: value });
    };

    const handleSave = () => {
        setAddresses([...addresses, address]);
        setShowForm(false);
        setAddress({
            name: '',
            mobile: '',
            pincode: '',
            locality: '',
            address: '',
            city: '',
            state: '',
            landmark: '',
            alternatePhone: '',
            addressType: 'home'
        });
    };

    const handleMenuOpen = (event, index) => {
        setAnchorEl(event.currentTarget);
        setSelectedAddressIndex(index);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        setSelectedAddressIndex(null);
    };

    const handleDeleteAddress = () => {
        const updatedAddresses = addresses.filter((_, index) => index !== selectedAddressIndex);
        setAddresses(updatedAddresses);
        handleMenuClose();
    };

    return (
        <Container>
            <Box sx={{ backgroundColor: 'white', p: 4, boxShadow: 3, borderRadius: 2 }}>
                <Typography variant="h2" gutterBottom>
                    Manage Addresses
                </Typography>
                <Button
                    variant="outlined"
                    color="primary"
                    fullWidth
                    style={{ marginTop: '30px', marginBottom: '20px', justifyContent: 'flex-start' }}
                    onClick={() => setShowForm(true)}
                    startIcon={<AddIcon />}
                >
                    ADD A NEW ADDRESS
                </Button>
                    {showForm && (
                <Paper sx={{ backgroundColor: '#F5FAFF', paddingLeft: 2, paddingRight: 2, paddingBottom: 2 }}>
                        <Box sx={{ marginBottom: '20px' }}>
                            <Button variant="contained" color="primary" style={{ marginTop: '30px', marginBottom: '20px' }}>
                                <Box sx={{ display: 'flex' }}>
                                    <MyLocationOutlinedIcon />
                                    <Typography sx={{ marginLeft: 1, marginTop: '2px' }}>Use my current location</Typography>
                                </Box>

                            </Button>
                            <Box>
                            <Box>
                            <TextField
                                label="Name"
                                name="name"
                                variant="outlined"
                                value={address.name}
                                onChange={handleChange}
                                sx={{ width:'280px'}}
                            />
                            <TextField
                                label="10-digit mobile number"
                                name="mobile"
                                variant="outlined"
                                value={address.mobile}
                                onChange={handleChange}
                                sx={{ marginLeft:2, width:'280px'}}
                            />
                            </Box>
                            <Box>
                            <TextField
                                label="Pincode"
                                name="pincode"
                                variant="outlined"
                                margin="normal"
                                value={address.pincode}
                                onChange={handleChange}
                                sx={{ width:'280px'}}
                            />
                            <TextField
                                label="Locality"
                                name="locality"
                                variant="outlined"
                                margin="normal"
                                value={address.locality}
                                onChange={handleChange}
                                sx={{ marginLeft:2, width:'280px'}}
                            />
                            </Box>
                            <TextField
                                label="Address (Area and Street)"
                                name="address"
                                multiline
                                variant="outlined"
                                margin="normal"
                                value={address.address}
                                onChange={handleChange}
                                sx={{ width:'576px'}}
                            />
                            <Box>
                            <TextField
                                label="City/District/Town"
                                name="city"
                                variant="outlined"
                                margin="normal"
                                value={address.city}
                                onChange={handleChange}
                                sx={{ width:'280px'}}
                            />
                            <FormControl sx={{ ml: 2, width: '280px', mt:'15px' }}>
                                    <InputLabel>State</InputLabel>
                                    <Select
                                        label="State"
                                        name="state"
                                        value={address.state}
                                        onChange={handleChange}
                                    >
                                        <MenuItem value=""><em>-- Select State --</em></MenuItem>
                                        <MenuItem value="Andaman">Andaman & Nicobar Islands</MenuItem>
                                        <MenuItem value="Bihar">Bihar</MenuItem>
                                        <MenuItem value="Chandigarh">Chandigarh</MenuItem>
                                        <MenuItem value="Delhi">Delhi</MenuItem>
                                        <MenuItem value="Goa">Goa</MenuItem>
                                        <MenuItem value="Haryana">Haryana</MenuItem>
                                        {/* Add more states as needed */}
                                    </Select>
                                </FormControl>
                            </Box>
                            <Box>
                            <TextField
                                label="Landmark (Optional)"
                                name="landmark"
                                variant="outlined"
                                margin="normal"
                                value={address.landmark}
                                onChange={handleChange}
                                sx={{width:'280px'}}
                            />
                            <TextField
                                label="Alternate Phone (Optional)"
                                name="alternatePhone"
                                variant="outlined"
                                margin="normal"
                                value={address.alternatePhone}
                                onChange={handleChange}
                                sx={{ marginLeft:2, width:'280px'}}
                            />
                            </Box>
                            <Typography variant="h5" gutterBottom sx={{ marginTop: '15px' }}>
                                Address Type
                            </Typography>
                            <RadioGroup
                                row
                                name="addressType"
                                value={address.addressType}
                                onChange={handleChange}
                                sx={{ marginTop: '15px' }}
                            >
                                <FormControlLabel value="home" control={<Radio />} label="Home" />
                                <FormControlLabel value="work" control={<Radio />} label="Work" />
                            </RadioGroup>
                            <Button variant="contained" color="primary" onClick={handleSave} sx={{ marginTop: '15px', width:'230px' }}>
                                SAVE
                            </Button>
                            <Button
                                variant="filled"
                                color="secondary"
                                onClick={() => setShowForm(false)}
                                sx={{ marginTop: '15px', marginLeft: '10px', width:'200px' }}
                            >
                                CANCEL
                            </Button>
                            </Box>
                        </Box>
                </Paper>
                    )}
                <List>
                    {addresses.map((addr, index) => (
                        <ListItem key={index}>
                            <ListItemText
                                primary={`${addr.name} ${addr.mobile}`}
                                secondary={`${addr.locality}, ${addr.address}, ${addr.city}, ${addr.state} - ${addr.pincode}`}
                            />
                            <IconButton edge="end" aria-label="more" onClick={(e) => handleMenuOpen(e, index)}>
                                <MoreVertIcon />
                            </IconButton>
                        </ListItem>
                    ))}
                </List>
                <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleMenuClose}
                >
                    <MenuItem onClick={handleDeleteAddress}>Delete</MenuItem>
                </Menu>
            </Box>
        </Container>
    );
}

export default ManageAddress;
